import { SVGProps } from "react";

export const Clock2Icon = ({
  size = 16,
  ...rest
}: SVGProps<SVGSVGElement> & { size?: number }) => {
  /* Render */
  const render = () => (
    <svg fill="none" viewBox="0 0 24 24" width={size} height={size} {...rest}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M5.136 18.864 6.55 17.45"
        strokeWidth="1"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M11.5 21.5v-2"
        strokeWidth="1"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="m17.864 18.864 -1.415 -1.414"
        strokeWidth="1"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="m5.136 6.13702 1.414 1.414"
        strokeWidth="1"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M2.5 12.5h2"
        strokeWidth="1"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M20.5 12.5h-2"
        strokeWidth="1"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="m17.864 6.13702 -1.415 1.414"
        strokeWidth="1"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M11.5 4.5v8h4"
        strokeWidth="1"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M6.952 23.5 0.5 17.048V7.952L6.952 1.5h9.096L22.5 7.952v9.096L16.048 23.5H6.952Z"
        strokeWidth="1"
      />
    </svg>
  );
  return render();
};
